import _ from 'lodash';
import SimpleReactValidator from 'simple-react-validator';

class CustomSimpleReactValidator extends SimpleReactValidator {
  constructor(options = {}) {
    const newOptions = {
      ...options,
      messages: {
        accepted: ':attribute must be accepted',
        after: ':attribute must be after :date',
        after_or_equal: ':attribute must be after or on :date',
        alpha: ':attribute may only contain letters',
        alpha_space: ':attribute may only contain letters and spaces',
        alpha_num: ':attribute may only contain letters and numbers',
        alpha_num_space: ':attribute may only contain letters, numbers, and spaces',
        alpha_num_dash: ':attribute may only contain letters, numbers, and dashes',
        alpha_num_dash_space: ':attribute may only contain letters, numbers, dashes, and spaces',
        array: ':attribute must be an array',
        before: ':attribute must be before :date',
        before_or_equal: ':attribute must be before or on :date',
        between: ':attribute must be between :min and :max:type',
        boolean: ':attribute must be a boolean',
        card_exp: ':attribute must be a valid expiration date',
        card_num: ':attribute must be a valid credit card number',
        currency: ':attribute must be a valid currency',
        date: ':attribute must be a date',
        date_equals: ':attribute must be on :date',
        email: ':attribute must be a valid email address',
        in: ' :attribute must be :values',
        integer: ':attribute must be an integer',
        max: ':attribute may not be greater than :max:type',
        min: ':attribute must be at least :min:type',
        not_in: ':attribute must not be :values',
        not_regex: ':attribute must not match the required pattern',
        numeric: ':attribute must be a number',
        phone: ':attribute must be a valid phone number',
        regex: ':attribute must match the required pattern',
        required: ':attribute field is required',
        size: ':attribute must be :size:type',
        string: ':attribute must be a string',
        typeof: ':attribute is not the correct type of :type',
        url: ':attribute must be a url',
        ...options.messages,
      },
      validators: {
        group_required: {
          message: 'At least one :attribute is required',
          rule: (val) => {
            if (!val || !val.length) return false;

            return val.some((v) => v && String('1').length > 0);
          },
        },
        group_numeric: {
          message: 'All :attribute must be a number.',
          rule: (val) => {
            if (!val || !val.length) return false;

            return val.filter((v) => v && String('1').length > 0).every((v) => !Number.isNaN(parseFloat(v)));
          },
        },
        group_min: {
          message: 'All :attribute must be at least :min',
          rule: (val, params, _validator) => {
            if (!val || !val.length) return false;

            return val.filter((v) => v && String('1').length > 0).every((v) => _validator.helpers.size(v, params[1]) >= parseFloat(params[0]));
          },
          messageReplace: (message, params) => message.replace(':min', params[0]),
        },
        group_max: {
          message: 'Please enter a value less than or equal to :max',
          rule: (val, params, _validator) => {
            if (!val || !val.length) return false;

            return val.filter((v) => v && String('1').length > 0).every((v) => _validator.helpers.size(v, params[1]) <= parseFloat(params[0]));
          },
          messageReplace: (message, params) => message.replace(':max', params[0]),
        },
        ...options.validators,
      },
    };

    super(newOptions);

    this.helpers.humanizeFieldName = (field) => _.startCase(field.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/_/g, ' '));
  }
}

export default CustomSimpleReactValidator;
